import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { Clickable } from '@carvana/merch-components';
import { useContext, useEffect, useRef } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import { useDDAddAction } from '~/hooks/common/telemetry';
import BangCircleIcon from '~/icons/BangCircle';
import { getAnalytics, getGeoLocation } from '~/selectors';
import useSelector from '~/store/useSelector';
import { getUserId } from '~/utilities';
import styles from './DeliveryUnavailableBanner.module.css';
import useShowDeliveryUnavailableBanner from './useShowDeliveryUnavailableBanner';

function useSendEvent(shouldSend: boolean, zip: string) {
  const { trackEvent } = useContext(AnalyticsContext);
  const { correspondingSearchRequestId } = useSelector(getAnalytics);

  const zipRef = useRef(zip);
  useEffect(() => {
    zipRef.current = zip;
  }, [zip]);

  useEffect(() => {
    if (!shouldSend) return;
    trackEvent('Delivery Unavailable - Banner Shown', {
      userId: getUserId(),
      searchRequestId: correspondingSearchRequestId,
      zip: zipRef.current
    });
  }, [correspondingSearchRequestId, shouldSend, trackEvent]);
}

export default function DeliveryUnavailableBanner() {
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const { zip } = useSelector(getGeoLocation);
  const showBanner = useShowDeliveryUnavailableBanner();

  useSendEvent(showBanner, zip);
  useDDAddAction('Delivery Unavailable - Banner Shown', showBanner);

  return showBanner ? (
    <div
      className="grid grid-flow-col items-center justify-center gap-8 bg-grey-1 py-16 tl-header-xs m:tl-header-s"
      data-qa="delivery-unavailable-banner"
    >
      <BangCircleIcon className={styles['bang-circle']} />
      <span>Delivery unavailable for {zip}</span>
      <Clickable
        className="anchor pointer-events-auto"
        onClick={() => setGeolocationModalOpen(true)}
        data-analytics-id="Delivery Unavailable - Change Location"
      >
        Change Location
      </Clickable>
    </div>
  ) : null;
}
